(() => {
  const storageKey = `firn-collection-scroll:${window.location.pathname}${window.location.search}`;
  const navigationEntry = performance.getEntriesByType('navigation')[0];
  const isHistoryNavigation = navigationEntry?.type === 'back_forward';
  let framePending = false;

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const savePosition = () => {
    sessionStorage.setItem(storageKey, String(window.scrollY));
  };

  const restorePosition = () => {
    if (!isHistoryNavigation) return;
    const storedPosition = Number.parseInt(sessionStorage.getItem(storageKey), 10);
    if (!Number.isFinite(storedPosition)) return;
    requestAnimationFrame(() => window.scrollTo({ top: storedPosition, left: 0, behavior: 'auto' }));
  };

  window.addEventListener('scroll', () => {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(() => {
      savePosition();
      framePending = false;
    });
  }, { passive: true });

  window.addEventListener('pagehide', savePosition);
  window.addEventListener('pageshow', restorePosition, { once: true });
})();
